const ButtonLayout = {
    Memory: {
        left: "24.77%",
    },
    StepMode: {
        left: "33.96%",
    },
    Play: {
        left: "43.15%",
    },
    Record: {
        left: "52.34%",
    },
    VCO1: {
        left: "61.53%",
    },
    VCO2: {
        left: "70.72%",
    },
    VCO3: {
        left: "79.91%",
    },
    Func: {
        left: "89.1%",
    }
}

export default ButtonLayout;